import India from "../Statics/india.png";
import Pakistan from "../Statics/pakistan.png";
import England from "../Statics/england.png";
import Australia from "../Statics/australia.png";
 export const teamdata= [
  {
    "name": "India",
    "flag": India,
    "points":"10",
    "matchesplayed":"6",
    "profile": {
      "captian": " MS Dhoni",
      "visecaptian": "Virat Kolhi",
      "profile": "The India men's national cricket team, also known as Team India and Men in Blue, is governed by the Board of Control for Cricket in India, and is a Full Member of the International Cricket Council with Test, One-Day International and Twenty20 International status."
    },
    "players": [
      {
        "name": "Rohit Sharma",
        "age": "34",
        "type": "batsman"
      },
      {
        "name": "Virat Kohli",
        "age": "30",
        "type": "batsman"
      },
      {
        "name": "MS Dhoni",
        "age": "37",
        "type": "wicketkeeper batter"
      },
      {
        "name": "Jadeja",
        "age": "30",
        "type": "allrounder"
      },
      {
        "name": "Bhuvaneshwar Kumar",
        "age": "29",
        "type": "bowler"
      },
      {
        "name": "Mohammed Shami",
        "age": "28",
        "type": "bowler"
      },
      {
        "name": "Kuldeep Yadav",
        "age": "24",
        "type": "bowler"
      }
    ]
  },
  {
    "name": "Australia",
    "flag":Australia,
    "points":"6",
    "matchesplayed":"6",
    "profile": {
      "captian": "Aaron Finch",
      "visecaptian": "Pat Cummins",
      "profile": "The Australia men's national cricket team represents Australia in men's international cricket.Australia is the most successful team in Test cricket history, in terms of overall wins, win-loss ratio and wins percentage."
    },
    "players": [
      {
        "name": "Aaaron Finch",
        "age": "32",
        "type": "batsman"
      },
      {
        "name": "David Warner",
        "age": "32",
        "type": "batsman"
      },
      {
        "name": "Alex Carey",
        "age": "27",
        "type": "wicketkeeper batter"
      },
      {
        "name": "Glenn Maxwell",
        "age": "30",
        "type": "allrounder"
      },
      {
        "name": "Pat Cummins",
        "age": "25",
        "type": "bowler"
      },
      {
        "name": "Mitchell Starc",
        "age": "29",
        "type": "bowler"
      },
      {
        "name": "Adam Zampa",
        "age": "27",
        "type": "bowler"
      }
    ]
  },
  {
    "name": "Pakistan",
    "flag":Pakistan,
    "points":"4",
    "matchesplayed":"6",
    "profile": {
      "captian": "Babar Azam",
      "visecaptian": "Sarfaraz Ahmed",
      "profile": "The Pakistan cricket team made its Test cricket debut in 1952 and has since become one of the most successful teams in modern cricket. The team reached the semi-finals of the 1979,1983, 1987 and 2011 World Cups, and finals in 1992 and 1999, and won the 1992 ICC Cricket World Cup by defeating England in the final with the captaincy of Imran Khan"
    },
    "players": [
      {
        "name": "Babar Azam",
        "age": "24",
        "type": "batsman"
      },
      {
        "name": "Sarfaraz Ahmed",
        "age": "33",
        "type": "wicketkeeper batter"
      },
      {
        "name": "Fakhar Zaman",
        "age": "30",
        "type": "batsman"
      },
      {
        "name": "Mohammad Nawaz",
        "age": "26",
        "type": "allrounder"
      },
      {
        "name": "Hasan Ali",
        "age": "26",
        "type": "bowler"
      },
      {
        "name": "Shaheen Shah Afridi",
        "age": "20",
        "type": "bowler"
      },
      {
        "name": "Usman Qadir",
        "age": "27",
        "type": "bowler"
      }
    ]
    },
      {
        "name": "England",
        "flag":England,
        "matchesplayed":"6",
        "points":"4",
        "profile": {
          "captian": "Eoin Morgan",
          "visecaptian": "Jos buttler",
          "profile": "The England cricket team represents England and Wales in international cricket. Since 1997, it has been governed by the England and Wales Cricket Board (ECB), having been previously governed by Marylebone Cricket Club (the MCC) since 1903."
        },
        "players": [
          {
            "name": "Eoin Morgan",
            "age": "32",
            "type": "batsman"
          },
          {
            "name": "Jos Buttler",
            "age": "28",
            "type": "batsman"
          },
          {
            "name": "Jonny Bairstow",
            "age": "29",
            "type": "wicketkeeper batter"
          },
          {
            "name": "Moeen Ali",
            "age": "31",
            "type": "allrounder"
          },
          {
            "name": "Jofra Archer",
            "age": "24",
            "type": "bowler"
          },
          {
            "name": "Ben Stokes",
            "age": "27",
            "type": "bowler"
          },
          {
            "name": "Mark Wood",
            "age": "29",
            "type": "bowler"
          }
        ]
      },
    
      
    
 
]
